import React, { useEffect } from 'react';
import { SignIn } from '@clerk/clerk-react';
import { useSearchParams, useLocation } from 'react-router-dom';

export default function SignInPage() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const redirectUrl = searchParams.get('redirect') || searchParams.get('redirect_url') || '/dashboard';

  // Handle SSO callback errors
  useEffect(() => {
    // Check if we're on an SSO callback path and there's an error
    if (location.pathname.includes('/sso-callback')) {
      const error = searchParams.get('error');
      const errorDescription = searchParams.get('error_description');
      
      if (error) {
        console.log('SSO Error:', error, errorDescription);
        // Redirect back to sign-in page after a brief delay to show any error message
        setTimeout(() => {
          window.location.href = '/sign-in';
        }, 2000);
      }
    }
  }, [location.pathname, searchParams]);

  return (
    <div className="flex justify-center items-center h-screen">
      <SignIn
        path="/sign-in"
        routing="path"
        signUpUrl="/sign-up"
        fallbackRedirectUrl={redirectUrl}
      />
    </div>
  );
}
